//Module脚本
var ModuleList = {
    'LoginController': 'login_controller'
    , 'MainSceneController': 'mainscene_controller'
    , 'MainUiController': 'mainui_controller'
    , 'RoleController': 'role_controller'
    , 'BattleController': 'battle_controller'
    , 'MailController': 'mail_controller'
    , "BackpackController": "backpack_controller"
    , "FriendController": "friend_controller"
    , "ExchangeController": "exchange_controller"
    , "OnlinegiftController": "onlinegift_controller"
    , "EsecsiceController": "esecsice_controller"
    , "ChatController": "chat_controller"
    , "StoneDungeonController": "stone_dungeon_controller"
    , "PartnersummonController": "partnersummon_controller"
    , "TaskController": "task_controller"
    , "GuildController": "guild_controller"
    , "HeroController": "hero_controller"
    , "GuildskillController": "guildskill_controller"
    , "RankController": "rank_controller"
    , "RedBagController": "redbag_controller"
    , "GuildBossController": "guildboss_controller"
    , "HallowsController": "hallows_controller"
    , "Battle_dramaController": "battle_drama_controller"
    , "VipController": "vip_controller"
    , "StartowerController": "startower_controller"
    , "WelfareController": "welfare_controller"
    , "ArenaController": "arena_controller"
    , "EndlessTrailController": "endless_trail_controller"
    , "HeroexpeditController": "heroexpedit_controller"
    , "PrimusController": "primus_controller"
    , "SeerpalaceController": "seerpalace_controller"
    , "WorldmapController": "worldmap_controller"
    , "ChatItemController": "chat_item_controller"
    , "GuildeController": "guide_controller"
    , "StoryController": "story_controller"
    , "VoyageController": "voyage_controller"
    , "ActionController": "action_controller"
    , "MallController": "mall_controller"
    , "LevupgradeController": "levupgrade_controller"
    , "InvitecodeController": "invitecode_controller"
    , "LookController": "look_controller"
    , "GuildwarController": "guildwar_controller"
    , "VedioController": "vedio_controller"
    , "AdventureActivityController": "adventureactivity_controller"
    , "AdventureController": "adventure_controller"
    , "TimesummonController": "timesummon_controller"
    , "PromptController": "prompt_controller"
    , "NewfirstchargeController": "newfirstcharge_controller"
    , "DaychargeController": "daycharge_controller"
    , "OrderactionController": "orderaction_controller"
    , "LimitexerciseController": "limitexercise_controller"
};

var DataList = [
    "activity_data",
    "adventure_data",
    "arena_champion_data",
    "arena_data",
    "attr_data",
    "avatar_data",
    "battle_act_data",
    "battle_bg_data",
    "boss_data",
    "buff_data",
    "charge_data",
    "checkin_data",
    "city_data",
    "color_data",
    "combat_halo_data",
    "combat_type_data",
    "cross_ground_data",
    "cross_show_data",
    "dailyplay_data",
    "days_rank_data",
    "day_goals_data",
    "dial_data",
    "drama_chat_data",
    "drama_data",
    "dungeon_data",
    "dungeon_scene_data",
    "dungeon_stone_data",
    "effect_data",
    "endless_data",
    "escort_data",
    "exchange_data",
    "expedition_data",
    "face_data",
    "feat_data",
    "formation_data",
    "function_data",
    "gift_data",
    "gm_data",
    "group_control_data",
    "guild_data",
    "guild_dun_data",
    "guild_quest_data",
    "guild_skill_data",
    "guild_war_data",
    "hallows_data",
    "holiday_client_data",
    "holiday_exchange_data",
    "holiday_groupon_data",
    "holiday_war_order_data",
    "honor_data",
    "invite_code_data",
    "item_data",
    "item_product_data",
    "lev_gift_data",
    "loading_desc_data",
    "login_days_data",
    "looks_data",
    "main_scene_data",
    "misc_data",
    "month_fund_data",
    "notice_data",
    "partner_artifact_data",
    "partner_data",
    "partner_eqm_data",
    "partner_field_data",
    "partner_skill_data",
    "power_gift_data",
    "primus_data",
    "privilege_data",
    "quest_data",
    "random_name_data",
    "recommend_data",
    "recruit_award_data",
    "recruit_data",
    "recruit_high_data",
    "recruit_holiday_data",
    "recruit_holiday_elite_data",
    "role_data",
    "shipping_data",
    "skill_data",
    "source_data",
    "star_data",
    "star_gift_data",
    "star_tower_data",
    "stronger_data",
    "unit_data",
    "video_data",
    "vip_data",
    "welfare_data",
    "tri_gift_data",
    "holiday_lanterm_adventure_data",
    "main_quest_data",
    "holiday_boss_new_data",
    "partner_skin_data",
];

module.exports = {
    module_list: ModuleList,
    data_list: DataList
};